import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface NavRemindersMenuProps {
  allRemindersUrl: string;
  createReminderUrl: string;
}

export const NavRemindersMenu: React.FC<NavRemindersMenuProps> = ( {
  allRemindersUrl,
  createReminderUrl,
} ) => {
  const { t } = useTranslation( [ 'base' ] );

  return (
    <Dropdown.Menu
      alignRight
      className="profile-notification min-wid-230 emil-styled py-3"
      id="remindersMenu"
    >
      <Dropdown.Item href={ allRemindersUrl }>
        { t( 'reminders.allReminders' ) }
        <i className="feather icon-external-link ml-1" />
      </Dropdown.Item>
      <Dropdown.Item href={ createReminderUrl }>
        { t( 'reminders.createReminder' ) }
        <i className="feather icon-external-link ml-1" />
      </Dropdown.Item>
    </Dropdown.Menu>
  );
};
